<template>
  <div>
    <div class="d-flex">
      <div>
        <div class="sample-image">
          <el-image
            :src="data.defaultImageUrl || '/image/static/img/nopic.jpg'"
            :preview-src-list="[
              data.defaultImageUrl || '/image/static/img/nopic.jpg',
            ]"
            style="width: 140px; height: calc(100% - 10px)"
          >
            <div slot="error" style="width: 100%; height: 100%">
              <img
                src="/image/static/img/nopic.jpg"
                style="width: 100%; height: 100%"
              />
            </div>
          </el-image>
        </div>
      </div>
      <div style="flex: 1">
        <el-descriptions border size="small" :column="3">
          <el-descriptions-item
            :label="$l('form_label_sampleStyleNo') || '样品编号'"
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ minWidth: '250px' }"
          >
            {{ data.sampleStyleNo }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_expoSampleStatus') || '展品状态'"
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '20px', 'text-align': 'center' }"
          >
            <el-tag
              v-if="data.v_expoSampleStatus"
              size="mini"
              :type="
                data.expoSampleStatus === 'D'
                  ? 'danger'
                  : data.expoSampleStatus === 'N'
                  ? 'light'
                  : 'success'
              "
            >
              {{ data.v_expoSampleStatus }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_guest_selection') || '客人选品'"
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '20px', 'text-align': 'center' }"
          >
            <el-tag
              v-if="data.v_isCustomerScan"
              size="mini"
              :type="data.isCustomerScan === 'Y' ? 'danger' : 'info'"
            >
              {{ data.v_isCustomerScan }}
            </el-tag>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions
          border
          :column="1"
          size="small"
          class="border-top-none"
        >
          <el-descriptions-item
            :label="$l('form_label_sampleName') || '样品中文名称'"
          >
            {{ data.sampleName }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_sampleNameEn') || '样品英文名称'"
          >
            {{ data.sampleNameEn }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <el-descriptions border :column="3" size="small" class="border-top-none">
      <el-descriptions-item :label="$l('form_label_category') || '样品品类'">
        {{ data.categoryName }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_sampleSource') || '样品来源'"
      >
        {{ data.v_sampleSource }}
      </el-descriptions-item>
      <el-descriptions-item :label="$l('form_label_sampleSpec') || '样品尺寸'">
        {{ `${data.sampleSpec || ''} ${data.sampleSizeUnit || ''}` }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Object, default: () => {} },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .border-top-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }

  .el-descriptions-row {
    display: flex;
    &:last-child {
      border-right: 1px solid #ebeef5;
    }
  }
  .el-descriptions-item__label {
    width: 100px;
    // border-right: none !important;
  }
  .el-descriptions-item__label + .el-descriptions-item__content {
    border-right: none !important;
    border-left: none !important;
  }
  .el-descriptions-item__content {
    flex: 1;
  }
}
.sample-image {
  width: 150px;
  height: 108px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ebeef5;
  border-right: none !important;
}
</style>
